export const calculatorHTMItemValues = [
    {
        code: 15,
        label: 'HTM engineers in alignment with fleet needs'
    },
    {
        code: 30,
        label: 'HTM engineers not fully aligned with fleet needs'
    },
    {
        code: 50,
        label: 'HTM engineers not aligned with fleet need'
    }
] as const;

export type CalculatorHTMItemValuesType = typeof calculatorHTMItemValues[number]['code'];

